import { wplToken } from '@atlassiansox/wpl-token';
import { getColor, getMediaDown } from '@atlassiansox/wpl-utils';
import { css } from '@emotion/react';

export const containerStyles = css`
  flex-direction: column;
  align-items: center;
  align-self: stretch;
  color: ${getColor('n0')};
  display: none;

  ${getMediaDown('md')} {
    display: block;
  }
`;

export const wrapperStyles = css`
  position: fixed;
  cursor: pointer;
  bottom: 0;
  left: 0;
  display: flex;
  width: 100%;
  height: 5.875rem;
  padding-bottom: 0.625rem;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  flex-shrink: 0;
  border: 0rem solid ${getColor('b400')};
  background: ${getColor('b400')};
`;

export const priceTotalStyles = css`
  display: flex;
  align-items: center;
`;

export const totalStyles = css`
  font-family: var(--bxp-charlie-display-font-family);
  font-size: 1.5rem;
  font-weight: 500;
  line-height: 2rem;
`;

export const currencyStyles = css`
  font-family: var(--bxp-charlie-text-font-family);
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.125rem;
  height: 1.5rem;
  padding-left: ${wplToken('space.100')};
`;

export const estimatedCostStyles = css`
  font-family: var(--bxp-charlie-text-font-family);
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.125rem;
`;

export const iconStyles = css`
  width: 1.125rem;
  height: 1.125rem;
  flex-shrink: 0;
`;
